import Model  from '@/util/v01/ActiveModel';

export default class Sidang extends Model { 
    static backend = '/ppdb/sidang/'; 
   
    static saveStep(body={}, params={}){
      return this.api.post(this.backend + 'save-step', body, params);
    }

    static seluruh(params = {}){
      return this.api.get(this.backend+'seluruh', params).then(res => {          
        return res.status == 200 ? res.data : {};
      });
    }

    static step(params = {}){
      return this.api.get(this.backend+'step', params).then(res => {          
        return res.status == 200 ? res.data : {};
      });
    }

    static quetionnaires(params = {}){
      return this.api.get(this.backend+'quetionnaires', params).then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }

    static maxStep(params = {}){
      return this.api.get(this.backend+'max-step', params).then(res => {          
        return res.status == 200 ? res.data : 0;
      });
    }

    static import(params = {}){
      return this.api.get(this.backend+'import', params);
    }

    static simpan(body={}, params={}){
      return this.api.post(this.backend + 'simpan', body, params).then(res=>{
        return res.status == 200 ? res.data : [];
      });
    }

    static release(body={}, params={}){
      return this.api.post(this.backend + 'release', body, params).then(res=>{
        return res.status == 200 ? res.data : [];
      });
    }

    static tingkats(params = {}){
      return this.api.get(this.backend + 'tingkats', params).then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }

    static settings(params={}){
      return this.api.get(this.backend + 'settings', params).then(res => {          
        return res.status == 200 ? res.data : [];
      });
    }
}

